/**
 * Lakeze 人客多 brand wordmark.
 * Renders the actual uploaded logo PNG (true-to-brand colors).
 *
 * Props:
 *   - size: "sm" (h=24) | "md" (h=36) | "lg" (h=56)
 *   - showChinese: default true. false → compact circular "L" icon only (for collapsed sidebar)
 *   - className
 */
const SIZES = { sm: 24, md: 36, lg: 56 };
const ICON_SIZES = { sm: 32, md: 40, lg: 48 };

export default function BrandLogo({ size = "md", showChinese = true, className = "" }) {
  const h = SIZES[size] || SIZES.md;

  if (!showChinese) {
    // Compact icon for collapsed sidebar — orange "L" on soft-orange circle
    const d = ICON_SIZES[size] || ICON_SIZES.md;
    return (
      <div
        className={`flex items-center justify-center rounded-full bg-[#FEF3E8] text-[#F26A1F] font-bold ${className}`}
        style={{ width: d, height: d, fontSize: d * 0.55, lineHeight: 1, fontFamily: "'Inter', system-ui, sans-serif" }}
        role="img"
        aria-label="Lakeze"
        data-testid="brand-logo-icon"
      >
        L
      </div>
    );
  }

  return (
    <img
      src="/lakeze-logo.webp"
      alt="Lakeze 人客多"
      height={h}
      style={{ height: h, width: "auto", display: "block" }}
      className={className}
      data-testid="brand-logo-full"
    />
  );
}
